<app-cd-popup>
  @if (data.title) {
  <cds-popup-title>{{ data.title | lang }}</cds-popup-title>
  }
  <cds-popup-content>
    @if (data.message) {
    <div class="cd-popup-continue-message cds-h2-light" innerHtml="{{ data.message | lang : data.params }}"></div>
    } @if (!data.message) {
    <div class="cd-popup-continue-message cds-h2-light" innerHtml="{{ 'common.action.cancel' | lang : data.params }}"></div>
    } @if (data.subMessage) {
    <div class="cd-popup-continue-message" innerHtml="{{ data.subMessage | lang }}"></div>
    }
  </cds-popup-content>
  <cds-popup-actions>
    <cds-button size="sm" [style]="'secondary'" (click)="cancle()">{{ 'common.cancel' | lang }} </cds-button>
    <cds-button size="sm" (click)="continue()">{{ data.continue || 'common.continue' | lang }} </cds-button>
  </cds-popup-actions>
</app-cd-popup>
